/**
 * Determines where to send a user after login/auth based on role.
 */
export function postLoginPath(user) {
  if (!user) return "/login";
  if (user.role === "admin") return "/admin";
  if (user.role === "org_manager") return "/org";
  if (user.role === "sponsor") return "/partner";
  if (!user.onboarding_complete) return "/onboarding";
  return "/dashboard";
}
